export function validateCpf(cpf) {
  // Remove caracteres não numéricos
  const sanitizedCPF = cpf.replace(/[^\d]/g, '');

  // Verifica se o CPF possui 11 dígitos ou é uma sequência repetida
  if (
    sanitizedCPF.length !== 11 ||
    /^(\d)\1+$/.test(sanitizedCPF) // Ex.: 111.111.111-11
  ) {
    return false;
  }

  // Converte para array de números
  const cpfArray = sanitizedCPF.split('').map(Number);

  // Valida o primeiro dígito verificador
  const firstVerifier = calculateVerifier(cpfArray, 10);
  if (cpfArray[9] !== firstVerifier) {
    return false;
  }

  // Valida o segundo dígito verificador
  const secondVerifier = calculateVerifier(cpfArray, 11);
  return cpfArray[10] === secondVerifier;
}

function calculateVerifier(cpfArray, factor) {
  const total = cpfArray
    .slice(0, factor - 1) // Considera apenas os dígitos relevantes
    .reduce((sum, num) => {
      sum += num * factor--;
      return sum;
    }, 0);

  const remainder = total % 11;
  return remainder < 2 ? 0 : 11 - remainder;
}
